module.exports = __webpack_public_path__ + "static/img/12.bcd0b72.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/zh/12.png
// module id = Jb23
// module chunks = 0